<div
	class="max-w-[872px] bg-off-white rounded-12px py-36px max-sm:px-0 px-[48px] m-auto"
>
	<div
		class="m-auto h-[56px] max-w-[406px] flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-light-grey rounded-[50px] text-dark-grey mt-[18px] mb-24px text-font-16 cursor-pointer"
	>
		<div
			class="mr-[8px] text-center w-[55%] max-mobile:m-[3px] text-medium-gray"
			(click)="
				selectedMediaType = null;
				galleryFilter.paging.pageNumber = 1;
				getGallery()
			"
			[ngClass]="{
				'activeClass ltr:font-DIN-bold rtl:font-bold leading-[20px]':
					selectedMediaType == null
			}"
		>
			<!-- prettier-ignore -->

			<p class=" text-font-14 m-0 leading-[20px ]" [ngClass]="{ 'ltr:font-DIN-bold rtl:font-bold leading-[20px]' : selectedMediaType == null }">{{'STATUS.ALL' | translate}}</p>
		</div>
		<div
			class="mr-[8px] text-center w-[55%] max-mobile:m-[3px] text-medium-gray"
			(click)="
				selectedMediaType = 5; galleryFilter.paging.pageNumber = 1; getGallery()
			"
			[ngClass]="{ activeClass: selectedMediaType == 5 }"
		>
			<!-- prettier-ignore -->
			<h1 class=" text-font-14 m-0 leading-[20px]" [ngClass]="{ 'ltr:font-DIN-bold rtl:font-bold leading-[20px]' : selectedMediaType == 5 }">{{'GALLERY.IMAGES' | translate}}</h1>
		</div>
		<div
			class="mr-[8px] text-center w-[55%] max-mobile:m-[3px] text-medium-gray"
			(click)="
				selectedMediaType = 10;
				galleryFilter.paging.pageNumber = 1;
				getGallery()
			"
			[ngClass]="{ activeClass: selectedMediaType == 10 }"
		>
			<!-- prettier-ignore -->
			<h1 class=" text-font-14 m-0 leading-[20px]" [ngClass]="{ 'ltr:font-DIN-bold rtl:font-bold leading-[20px]' : selectedMediaType == 10 }">{{'GALLERY.VIDEOS' | translate}}</h1>
		</div>
	</div>

	<div
		infiniteScroll
		[infiniteScrollDistance]="1"
		[infiniteScrollUpDistance]="1.5"
		[infiniteScrollThrottle]="50"
		(scrolled)="onScrollDown($event)"
	>
		<lightgallery
			[settings]="settings"
			[onInit]="onInit"
			class="grid grid-cols-3 gap-3 max-sm:grid-cols-2 max-smMobile:grid-cols-1"
		>
			<ng-container *ngFor="let image of gallery">
				<a
					*ngIf="image?.mediaType == 5"
					[attr.href]="imagPath + image?.url"
					[attr.data-sub-html]="image?.creationTime | date : 'MMM d, y'"
					class="h-[200px] w-auto relative"
				>
					<div
						class="bg-white rounded-full p-2 absolute top-3 right-3 w-9 cursor-pointer"
						(click)="
							$event.stopPropagation();
							$event.preventDefault();
							deleteMedia(image)
						"
					>
						<img src="assets/images/delete.svg" alt="" />
					</div>

					<img
						class="w-full h-full object-cover rounded"
						alt="img1"
						[src]="imagPath + image?.url"
					/>
				</a>
				<a
					*ngIf="image?.mediaType == 10"
					data-lg-size="1280-720"
					[attr.data-sub-html]="image?.creationTime | date : 'MMM d, y'"
					attr.data-video="{&quot;source&quot;: [{&quot;src&quot;:&quot;{{
						imagPath + image?.url
					}}&quot;, &quot;type&quot;:&quot;video/mp4&quot;}], &quot;tracks&quot;: [{&quot;src&quot;: &quot;{/videos/title.txt&quot;, &quot;kind&quot;:&quot;captions&quot;, &quot;srclang&quot;: &quot;en&quot;, &quot;label&quot;: &quot;English&quot;, &quot;default&quot;: &quot;true&quot;}], &quot;attributes&quot;: {&quot;preload&quot;: false, &quot;playsinline&quot;: true, &quot;controls&quot;: true} }"
					[attr.data-poster]="imagPath + image?.thumbnailUrl"
					class="h-[200px] w-auto relative"
				>
					<div
						class="bg-white rounded-full p-2 absolute top-3 right-3 w-9 cursor-pointer"
						(click)="$event.stopPropagation(); deleteMedia(image)"
					>
						<img src="assets/images/delete.svg" alt="" />
					</div>

					<img
						class="absolute right-0 left-0 m-auto top-0 bottom-0 w-9 cursor-pointer"
						src="assets/images/play.svg"
						alt=""
					/>

					<img
						class="w-full h-full object-cover rounded"
						alt="img1"
						[src]="imagPath + image?.thumbnailUrl"
					/>
				</a>
			</ng-container>
		</lightgallery>
	</div>
	<div *ngIf="!gallery?.length" class="text-center h-[45vh]">
		<div class="flex justify-center items-center text-center mt-14">
			<div>
				<img
					class="mb-12px lg:mt-0 mt-5 inline-block"
					src="../../../../../assets/images/no-gallery.svg"
					alt=""
				/>
				<p
					class="text-font-16 ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey"
				>
					{{ 'GALLERY.NO_GLLERY_FOUND' | translate }}
				</p>
			</div>
		</div>
		<!-- <app-no-data-found
			text="GALLERY.NO_GLLERY_FOUND"
			[imageName]="'no-gallery.svg'"
		></app-no-data-found> -->
		<div class="mt-2 gap-[8px] flex justify-center">
			<div class="flex bg-gradient text-off-white rounded-[6px]">
				<img
					src="../../../../../assets/images/video-square.svg"
					class="ltr:ml-2 rtl:mr-2"
					alt=""
				/>
				<button class="" (click)="uploadVideos()" mat-button>
					{{ 'ACTIONS.UPLOAD_VIDEO' | translate }}
				</button>
			</div>

			<div class="flex bg-gradient text-off-white rounded-[6px]">
				<img
					src="../../../../../assets/images/add-gallery.svg"
					class="ltr:ml-2 rtl:mr-2"
					alt=""
				/>
				<button class="" (click)="uploadImages()" mat-button>
					{{ 'ACTIONS.UPLOAD_IMG' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>

<app-fixed-button
	*ngIf="gallery?.length"
	buttonTitle="ACTIONS.UPLOAD_VIDEO"
	button2Title="ACTIONS.UPLOAD_IMG"
	img2Path="add-gallery.svg"
	imgPath="video-square.svg "
	(click2Event)="uploadImages()"
	(clickEvent)="uploadVideos()"
></app-fixed-button>
